export default {
  setup() {
    return {
      url: window.location.origin
    };
  }
};